import React from "react";
import { useMsal } from "@azure/msal-react";
import getClassNames from "../../Utils/getClassNames";
import Button from "./Button";
import { NO_RESULTS_GROUPS_KEY } from "../../Constants/cacheKeys";

function handleLogout(instance) {
	// Clear any session storage key
    sessionStorage.removeItem(NO_RESULTS_GROUPS_KEY);

	instance.logoutRedirect().catch(e => {
		console.error(e);
	});
}

export const SignOutButton = (props) => {
	const { instance } = useMsal();

	return (
		<>
			<Button className={getClassNames('btn-secondary', props.className)}
				onClick={() => handleLogout(instance)}
				text="Sign Out"
				id="sign-out-button" />
		</>
	);
}